export default __webpack_public_path__ + "static/media/chennaiCorporationLogo.9d022088.png";